import React from 'react';
import UserAssurances from './UserAssurances';
import config from 'config';

import { Container } from './elements';

const Assurances = ({ mode }) => {
  return (
    config.ASSURANCE_SHOW && (
      <Container $mode={mode}>
        <UserAssurances mode={mode} />
      </Container>
    )
  );
};

// TODO: move to Flow types
// Assurances.propTypes = {
//   isTa: PropTypes.bool.isRequired,
//   mode: PropTypes.oneOf(['btp', 'srp'])
// };

Assurances.defaultProps = {
  mode: 'srp',
};

export default Assurances;
